import SelectorVisualMediaGridPresentation from 'components/SelectorVisualMediaGrid/SelectorVisualMediaGridPresentation'

export default {
  Presentation: SelectorVisualMediaGridPresentation,
}
